import React from "react";
import TableBoolean from "../../components/Table/TableBoolean/TableBoolean";
import _ from "lodash";

const headerStyle = () => ({ borderColor: "#a81933" });
const columnStyle = () => ({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
});

const messageFormatter = (value, isHtmlContent) => {
  if (_.isEmpty(value)) return "No Message";

  const stripHtml = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]+>/g, "");
  }
  const hasHtml = value !== stripHtml(value);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      <div
        style={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {!isHtmlContent && hasHtml ? stripHtml(value) : value}
      </div>
    </div>
  );
};

export const columns = [
  {
    dataField: "statusName",
    text: "Status",
    sort: true,
    formatter: (_cell, row) => (
      <TableBoolean value={row.statusId === 1} text={row.statusName} />
    ),
    headerStyle: () => ({ width: "130px", ...headerStyle() }),
  },
  {
    dataField: "title",
    text: "Title",
    sort: true,
    headerStyle: headerStyle,
    style: columnStyle,
    formatter: (_cell, row) => row.title,
  },
  {
    dataField: "message",
    text: "Message",
    sort: true,
    headerStyle: headerStyle,
    style: columnStyle,
    formatter: (_cell, row) => messageFormatter(row.message, row.isHtmlContent),
  },
  {
    dataField: "imageFilename",
    text: "Image",
    sort: true,
    headerStyle: headerStyle,
    style: columnStyle,
  },
];

export const sorting = [
  {
    dataField: "message",
    order: "desc",
  },
];